<template>
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 200 200">
        <defs>
            <radialGradient
                id="radial-gradient"
                cx="-479.49"
                cy="-324.4"
                r="0.27"
                gradientTransform="translate(383632 259718.49) scale(800 800)"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset="0" stop-color="#09f"></stop>
                <stop offset="0.61" stop-color="#a033ff"></stop>
                <stop offset="0.93" stop-color="#ff5280"></stop>
                <stop offset="1" stop-color="#ff7061"></stop>
            </radialGradient>
        </defs>
        <path
            class="cls-1"
            style="fill: url(#radial-gradient)"
            d="M100.06.12C43.78.12.13,41.37.13,97.06c0,29.12,11.94,54.31,31.38,71.69a7.92,7.92,0,0,1,2.67,5.7l.55,17.79A8,8,0,0,0,46,199.31l19.84-8.75a8,8,0,0,1,5.34-.4A109.24,109.24,0,0,0,100.06,194C156.35,194,200,152.77,200,97.08S156.35.12,100.06.12Z"
        ></path>
        <path
            class="cls-2"
            style="fill: #ffffff"
            d="M40.05,125.41,69.41,78.84a15,15,0,0,1,21.68-4l23.36,17.51a6,6,0,0,0,7.22,0L153.2,68.4a4.75,4.75,0,0,1,6.89,6.32l-29.37,46.54a15,15,0,0,1-21.69,4L85.67,107.75a6,6,0,0,0-7.22,0L46.93,131.71A4.74,4.74,0,0,1,40.05,125.41Z"
        ></path>
    </svg>
</template>

<script>
export default {
    name: "FacebookIcon",
};
</script>

<style scoped></style>
